import { Observable, OperatorFunction, from } from 'rxjs';
import { concatMap, skip, take, toArray } from 'rxjs/operators';

export function paginateObservable<InputType>(
    offset: number,
    limit: number,
): OperatorFunction<
    InputType,
    {
        result: InputType[];
        original: InputType[];
        totalLength: number;
        offset: number;
        limit: number;
    }
>;
export function paginateObservable<InputType, R>(
    offset: number,
    limit: number,
    observableMappingFunc: OperatorFunction<InputType, R>,
): OperatorFunction<
    InputType,
    {
        result: R[];
        original: InputType[];
        totalLength: number;
        offset: number;
        limit: number;
    }
>;
export function paginateObservable<InputType, R>(
    offset: number,
    limit: number,
    observableMappingFunc?: OperatorFunction<InputType, R>,
): OperatorFunction<
    InputType,
    {
        result: R[];
        original: InputType[];
        totalLength: number;
        offset: number;
        limit: number;
    }
> {
    return source$ =>
        source$.pipe(
            toArray(),
            concatMap(async original => {
                let result$: Observable<any> = from(original).pipe(skip(offset), take(limit));
                if (observableMappingFunc) {
                    result$ = result$.pipe(observableMappingFunc);
                }
                const result = (await result$.pipe(toArray()).toPromise()) as unknown[] as R[];
                return {
                    limit,
                    offset,
                    original,
                    result,
                    totalLength: original.length,
                };
            }),
        );
}
